import { rem } from "polished";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: 0 ${rem(40)};

  .button-primitive {
    display: flex;
    justify-content: center;
    margin: ${rem(8)} auto 0;
  }

  ${(props) => props.$viewport.tablet`
    grid-gap: ${rem(24)};
    padding: 0;

    .button-primitive {
      margin-top: 0;
    }
  `};
`;

const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `};
`;

const ImageWrapper = withViewportStyle("div")`
  position: relative;
  margin: 0 auto ${rem(24)} auto;

  .image-primitive {
    max-width: ${rem(1000)};
    width: 100%;
  }

  .semicircle {
    position: absolute;
    z-index: var(--z-index-lowest);
    bottom: ${rem(-8)};
    left: 0;
    transform: rotate(90deg);
    transform-origin: left;

    & path {
      fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
    }
  }

  .circle {
    position: absolute;
    z-index: var(--z-index-lowest);
    top: 0;
    right: -${rem(120)};
    opacity: .6;

    & circle {
      fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_3]};
    }
  }

  .quarter-circle {
    position: absolute;
    z-index: var(--z-index-lowest);
    top: 0;
    right: 0;
    transform: rotate(180deg);
    
    & path {
      fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_3]};
    }
  }

  ${(props) => props.$viewport.tablet`
    .image-primitive {
      max-width: 100%;
      margin-bottom: 0;
    }
  `};
`;

export { Wrapper, PaddingWrapper, ImageWrapper };
